import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { GetRubricsQueryResponse, GetRubricsQueryParams } from "../../types/GetRubrics";

/**
     * @link /api/ms-content-infoportal-backend/v1/rubrics
     */
export async function getRubrics (params?: GetRubricsQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<GetRubricsQueryResponse>["data"]> {
    const { data: resData } = await client<GetRubricsQueryResponse>({
        method: "get",
        url: `/api/ms-content-infoportal-backend/v1/rubrics`,
        params,
        ...options
    });
    
    return resData;
};